// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderMobileCloseMenu: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 16,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 16 16" width={size} height={size}>
        <path
            fill="currentColor"
            d="M14.635 15.767c.31.31.822.31 1.132 0a.804.804 0 0 0 0-1.132L9.132 8l6.635-6.635a.804.804 0 0 0 0-1.132.804.804 0 0 0-1.132 0L8 6.868 1.365.233a.804.804 0 0 0-1.132 0 .804.804 0 0 0 0 1.132L6.868 8 .233 14.635a.804.804 0 0 0 0 1.132c.31.31.821.31 1.132 0L8 9.132z"
        />
    </svg>
);

export default React.memo(HeaderMobileCloseMenu);
